<app-login-layout class="app-light-theme">
  <main class="ata-auth-page ata-auth-page--register">
    <header class="ata-auth-topbar">
      <a class="ata-auth-brand" routerLink="/auth">
        <span class="ata-auth-brand__mark">A</span>
        <span class="ata-auth-brand__name">Auto Transport Alliance</span>
      </a>

      <nav class="ata-auth-nav">
        <a class="ata-auth-nav__link" routerLink="/auth">Log In</a>
        <a class="ata-auth-nav__link is-active" routerLink="/register">Registration</a>
        <a class="ata-auth-nav__link" routerLink="/forgot-password">Forgot Password</a>
      </nav>
    </header>

    <section class="ata-auth-hero">
      <div class="ata-auth-hero__visual">
        <img src="assets/image/auth-hero-bg.jpg" alt="Carrier onboarding background" />
      </div>
      <div class="ata-auth-hero__overlay"></div>

      <div class="ata-auth-hero__inner">
        <div class="ata-auth-grid">
          <aside class="ata-auth-info">
            <div>
              <p class="ata-auth-info__eyebrow">Carrier Onboarding</p>
              <h1 class="ata-auth-info__title">Register your carrier profile.</h1>
              <p class="ata-auth-info__copy">
                Apply to join Auto Transport Alliance using verified business, compliance, and contact information.
              </p>

              <div class="ata-auth-info__list">
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Required Documents</p>
                  <p class="ata-auth-info__value">MC certificate and proof of insurance are validated during onboarding.</p>
                </div>
                <div class="ata-auth-info__item">
                  <p class="ata-auth-info__label">Standards</p>
                  <p class="ata-auth-info__value">Aligned to shared inspection, accountability, and payout workflows.</p>
                </div>
              </div>
            </div>

            <p class="ata-auth-info__badge">Page 02</p>
          </aside>

          <section class="ata-auth-card ata-auth-card--wide">
            <p class="ata-auth-card__eyebrow">Application</p>
            <p class="ata-auth-card__intro">Complete all required fields to create a new carrier account.</p>
            <app-register-carrier></app-register-carrier>
          </section>
        </div>
      </div>
    </section>
  </main>
</app-login-layout>
